module.exports = __webpack_public_path__ + "static/media/53152820_2452988381443005_2203642063382118400_o.281f1953.jpg";